import React from "react";
import {appContainer, Subscribe} from "../../contexts/app";
import PageContainer from "../../components/PageContainer";
import {getPlaceInfo} from "../../components/Utilities";
import "./style.scss";

class MarkerCategories extends React.Component {
  render() {
    return (
      <PageContainer {...this.props} editMode={false}>
        <div className="blurBGPage" />
      </PageContainer>
    );
  }
}

export default routeProps => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        const placeInfo = getPlaceInfo(app, routeProps.location.query);
        const sidebarOpen = app.state.get("sidebarOpen");
        return (
          <React.Fragment>
            <MarkerCategories
              {...routeProps}
              {...placeInfo}
              markerTypeCategories={app.state.get("markerTypeCategories")}
              sidebarOpen={sidebarOpen}
            />
          </React.Fragment>
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/MarkerCategories/index.jsx